import React from 'react';
import { REGIONS, COUNTRIES, getCitiesForCountry } from '@/utils/geoData';

/**
 * Sélecteur pays + ville avec autocomplétion via datalist.
 * Priorité : Afrique → Europe → Amérique du Nord.
 * Réutilisé par TripForm et ShipmentForm.
 */
export function CountryCitySelector({
  country, onCountryChange,
  city, onCityChange,
  dirLabel,
  errCountry, errCity,
}) {
  const cities       = getCitiesForCountry(country);
  const countryListId = `cl-${dirLabel.replace(/\W/g, '')}`;
  const cityListId    = `ci-${dirLabel.replace(/\W/g, '')}`;
  const countryName   = COUNTRIES.find(c => c.code === country)?.name ?? '';
  // Identifiants de test : « from » pour le départ, « to » pour l'arrivée
  const side          = dirLabel === 'Départ' ? 'from' : 'to';

  const handleCountryChange = (e) => {
    const val = e.target.value;
    const match = COUNTRIES.find(c => c.name.toLowerCase() === val.toLowerCase());
    if (match) { onCountryChange(match.code); onCityChange(''); }
    else if (!val) { onCountryChange(''); onCityChange(''); }
  };

  return (
    <div className="sf-country-city">
      <div className="sf-field">
        <label className="sf-label">{dirLabel} · Pays <span className="sf-req">*</span></label>
        <input
          className={`sf-input ${errCountry ? 'err' : ''}`}
          list={countryListId}
          placeholder="Saisir ou choisir un pays…"
          data-testid={`input-country-${side}`}
          defaultValue={countryName}
          key={countryName}
          onChange={handleCountryChange}
        />
        <datalist id={countryListId}>
          {REGIONS.map(region =>
            region.countries.map(c => (
              <option key={c.code} value={c.name}>{region.label}</option>
            ))
          )}
        </datalist>
      </div>
      {country && (
        <div className="sf-field">
          <label className="sf-label">Ville <span className="sf-req">*</span></label>
          <input
            className={`sf-input ${errCity ? 'err' : ''}`}
            list={cityListId}
            placeholder="Saisir ou choisir une ville…"
            data-testid={`input-city-${side}`}
            value={city}
            onChange={e => onCityChange(e.target.value)}
          />
          <datalist id={cityListId}>
            {cities.map(c => <option key={c} value={c} />)}
          </datalist>
        </div>
      )}
    </div>
  );
}
